<template>
  <v-container>
    <v-layout row class="text-xs-center">
        <v-container style="position: relative;top: 13%;" class="text-xs-center">
            <h1>I am?</h1>
            <v-btn color="primary" @click="individual()">Individual</v-btn>
            <v-btn color="primary" @click="worker()">Health Worker</v-btn>
        </v-container>
    </v-layout>
  </v-container>
</template>

<script>
import EosService from '@/eosio/EosService';

export default {
  data() {
    return {
      pKey: '',
      eosio: null
    };
  },
  methods: {
    individual: async function(){
      this.$router.push('login');
    },
    worker: async function(){
      this.$router.push('worker');
    }
  }
};
</script>